export default __webpack_public_path__ + "static/media/icon-w@3x.405f0c7e.png";